import API_CLIENT from "../../utils/Api";

export async function GetNotifications() {
  return await API_CLIENT.get("/notifications");
}

export async function MarkNotificationRead(id) {
  return await API_CLIENT.patch(`/notifications/${id}`);
}
